import * as React from 'react';
import { registerDecorator } from '@avensia/excite-contentful/Document';
import { styled } from '@glitz/react';
import SharedLink from 'webapp/components/Link';
import { linkWithoutQueryParams } from 'webapp/link-url-decorator';

registerDecorator<Excite.Contentful.HyperlinkApiModel>(
  'a',
  styled(({ children, data, attributes }) => {
    const { url, ...linkAttributes } = data ?? {};
    const linkWithoutQuery = data?.to ? linkWithoutQueryParams(data) : {};
    if (children) {
      return (
        <Link to={url || (attributes?.['href'] as string)} {...linkAttributes} {...attributes} {...linkWithoutQuery}>
          {children}
        </Link>
      );
    }
    return (
      <Link to={url || (attributes?.['href'] as string)} {...linkAttributes} {...attributes} {...linkWithoutQuery} />
    );
  }),
);

const Link = styled(SharedLink, {
  textDecoration: 'underline',
  ':hover': {
    textDecoration: 'underline',
  },
});
